const ACTION_TYPES = {
    SIGN_IN: 'USER.SIGN_IN',
    UPDATE: 'USER.UPDATE',
    NOT_FOUND: 'USER.NOT_FOUND',
    DRAFT_STORE_DETAILS: 'DRAFT_STORE_DETAILS',
    DRAFT_ZIP_CODE: 'DRAFT_ZIP_CODE',
    CLEAR_UPPER_FUNNEL_DRAFT: 'CLEAR_UPPER_FUNNEL_DRAFT',
    STORE_CHANGED_FROM_HEADER: 'STORE_CHANGED_FROM_HEADER'
};

const initialState = {
    profileStatus: 0,
    profileLocale: '',
    isInitialized: false
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE:
            return Object.assign({}, state, action.data);
        case ACTION_TYPES.DRAFT_STORE_DETAILS: {
            const { preferredStoreInfo } = state;
            const nextState = {
                ...state,
                preferredStoreInfo: {
                    ...preferredStoreInfo,
                    draft: {
                        ...action.payload
                    }
                }

            };
            return nextState;
        }
        case ACTION_TYPES.CLEAR_UPPER_FUNNEL_DRAFT: {
            const { preferredStoreInfo } = state;
            const nextState = {
                ...state,
                draft: {},
                preferredStoreInfo: {
                    ...preferredStoreInfo,
                    draft: {}
                }
            };
            return nextState;
        }
        case ACTION_TYPES.DRAFT_ZIP_CODE: {
            const nextState = {
                ...state,
                draft: { preferredZipCode: action.payload }
            };
            return nextState;
        }
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
